import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pen chandellier?",
  "description": "",
  "published": "2007-01-15T00:00:00.000Z",
  "redirect_from": ["/blog/pen-chandellier/swizec/321"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Apparently even such a thing as an expensive, even beautiful, `}<a parentName="p" {...{
        "href": "http://inhabitat.com/2007/01/10/bic-ballpoint-pen-chandelier/"
      }}>{`chandellier`}</a>{` made completely out of ballpoint pens can and does exist. Biggest surprise of them all is how they dare give it a prise of 1000 USD.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      